import React, { ReactElement } from "react";
import {
  GridColDef,
  GridRenderCellParams,
  GridActionsCellItem,
} from "@mui/x-data-grid";
import { Edit as EditIcon, Delete as DeleteIcon } from "@mui/icons-material";
import { format } from "date-fns";
import { parseDate } from "../../lib";
import { ApprovalStatus, Absence, TimeInLieu } from "../../API";
import { Tooltip } from "../../components";

type Actions = {
  showUpdateModal: () => void;
  showDeleteModal: () => void;
  timeInLieus: TimeInLieu[];
  employeeID: string;
  maxDate: Date;
  minDate: Date;
};

type RowAction = {
  label: string;
  icon: ReactElement;
  onClick: (
    params: GridRenderCellParams & {
      timeInLieus?: TimeInLieu[];
      employeeID?: string;
      maxDate?: Date;
      minDate?: Date;
    }
  ) => void;
};

const displayStatus = (sts: string) => sts[0].toUpperCase() + sts.slice(1);

const disabledAction = (status: string) => status !== ApprovalStatus.pending;

const renderActionButton = (
  { icon, label, onClick }: RowAction,
  params: GridRenderCellParams,

  timeInLieus?: TimeInLieu[],
  employeeID?: string,
  maxDate?: Date,
  minDate?: Date
) =>
  disabledAction(params.row.approvalStatus) ? (
    <></>
  ) : (
    <Tooltip title={label} placement="top">
      <div data-testid={`grid-${label.toLowerCase()}-button`}>
        <GridActionsCellItem
          label={label}
          onClick={() => {
            onClick({
              ...params,
              timeInLieus,
              employeeID,
              maxDate,
              minDate,
            });
          }}
          icon={icon}
          {...({} as any)}
        />
      </div>
    </Tooltip>
  );

export const columns = ({
  showUpdateModal,
  showDeleteModal,
  timeInLieus,
  employeeID,
  maxDate,
  minDate,
}: Actions): GridColDef<Absence>[] => [
  {
    field: "dateTaken",
    headerName: "Date",
    minWidth: 112,
    renderCell: ({ value }) => format(parseDate(value), "dd/MM/yyyy"),
  },
  {
    field: "hoursTaken",
    headerName: "Hours",
  },
  {
    field: "description",
    headerName: "Description",
    flex: 1,
  },
  {
    field: "approvalStatus",
    headerName: "Approval status",
    width: 128,
    renderCell: ({ value }) => displayStatus(value ?? "pending"),
  },
  {
    field: "actions",
    headerName: "Actions",
    cellClassName: "actions",
    width: 96,
    sortable: false,
    headerAlign: "left",
    renderCell: (params) => (
      <>
        {renderActionButton(
          {
            label: "Edit",
            icon: <EditIcon />,
            onClick: showUpdateModal,
          },
          params,
          timeInLieus,
          employeeID,
          maxDate,
          minDate
        )}
        {renderActionButton(
          {
            label: "Delete",
            icon: <DeleteIcon />,
            onClick: showDeleteModal,
          },
          params
        )}
      </>
    ),
  },
];

export const hiddenColumnsMobile: { [key: string]: boolean } = {};
